import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { UseCase } from "../../base/use-case";
import { JobsRepository } from "../../repositories";
import { DeleteJobRequest } from "../../domain/requests/jobs/delete-jobs-request";

@Injectable({ providedIn: 'root' })
export class DeleteJobUsecase implements UseCase<DeleteJobRequest, boolean> {

  constructor(private jobRepository: JobsRepository) {
  }

  execute(params: DeleteJobRequest): Observable<boolean> {
    return this.jobRepository.deleteJob(params);
  }

}
